import React from 'react';
import { CoverImagePlayButton } from '@components/basics/CoverImagePlayButton';
import type { FragmentType } from '@graphql/reactQuery';
import { gql } from '@graphql/reactQuery';
import {
  getFragment,
  ReleaseCoverImagePlayButtonFragmentDoc,
  ReleaseType,
} from '@graphql/reactQuery';
import { usePlayButton } from '@hooks/usePlayButton';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ReleaseCoverImagePlayButton on Release {
    id
    title
    createdAt
    artist {
      id
      name
      webappUri
    }
    staticCoverImage {
      id
      url
    }
    coverImage {
      id
      url
      dominantColor
    }
    track {
      id
      normalizedPeaks
      duration
    }
    type
    webappUri
  }
`);

export const ReleaseCoverImagePlayButton = ({
  releaseFrag,
}: {
  releaseFrag: FragmentType<ReleaseCoverImagePlayButtonFragmentDoc>;
}) => {
  const release = getFragment(ReleaseCoverImagePlayButtonFragmentDoc, releaseFrag);
  const { coverImage, staticCoverImage, title, type, track } = release;

  const coverImageUrl = staticCoverImage?.url || coverImage.url;

  const { isPlaying, onPlayClick, isLoading } = usePlayButton({
    trackId: track.id,
    isAlbum: type !== ReleaseType.Single,
  });

  return (
    <CoverImagePlayButton
      coverImageUrl={coverImageUrl}
      title={title}
      isPlaying={isPlaying}
      onPlayClick={onPlayClick}
      isLoading={isLoading}
    />
  );
};
